'use client';

import { Elements } from '@prezly/content-renderer-react-js';
import type { OEmbedInfo, StoryBookmarkNode } from '@prezly/story-content-format';
import { useMemo } from 'react';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import { optimizeOembedThumbnail } from './lib';

interface Props {
    node: StoryBookmarkNode;
    referencedStories: Record<string, OEmbedInfo> | undefined;
}

export function StoryBookmark({ node, referencedStories }: Props) {
    const isMobile = useBreakpoint('xs', 'below');
    const referencedStory = referencedStories?.[node.story.uuid];

    const referencedStoryWithResizedThumbnail = useMemo(() => {
        if (!referencedStory) {
            return undefined;
        }

        return optimizeOembedThumbnail(referencedStory, node.layout, isMobile);
    }, [node, referencedStory, isMobile]);

    if (!referencedStoryWithResizedThumbnail) {
        return null;
    }

    return (
        <Elements.StoryBookmark node={node} storyOEmbedInfo={referencedStoryWithResizedThumbnail} />
    );
}
